import React from 'react';
import { Message } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import css from './rateError.module.css';

function RateError({ event, price = null, maxPrice = null, currency = null }) {
    const { t } = useTranslation();

    const max = React.useMemo(() => {
        return new Intl.NumberFormat(event?.default_language, { style: 'currency', currency: currency || event.currency }).format(maxPrice);
    }, [maxPrice, currency, event]);

    const min = React.useMemo(() => {
        return new Intl.NumberFormat(event?.default_language, { style: 'currency', currency: currency || event.currency }).format(1);
    }, [currency, event]);

    if (maxPrice) {
        return (
            <div className={css['rate']}>
                <Message mini title={t('ticket.rates.infos.rateErrorTitle')} type="danger" visible>
                    {t('ticket.rates.infos.rateError', { amount: max })}
                </Message>
            </div>
        );
    }
    if (price < 1) {
        return (
            <div className={css['rate']}>
                <Message mini title={t('ticket.rates.infos.rateMinErrorTitle')} type="danger" visible>
                    {t('ticket.rates.infos.rateMinError', { amount: min })}
                </Message>
            </div>
        );
    }
}

export default RateError;
